import { Component } from '@angular/core';
import { HeroComponent } from '../../../shared/hero/hero.component';
import { CommonModule } from '@angular/common';
import { AboutUsComponent } from '../../../shared/about-us/about-us.component';
import { ServiceCarouselComponent } from "../../../shared/service-carousel/service-carousel.component";

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [HeroComponent, CommonModule, AboutUsComponent, ServiceCarouselComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent {

}
